import { useContext } from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { MBText } from '@shared/components/MBText';
import { MBView } from '@shared/components/MBView';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

interface Props {
  message?: string;
  isRounded?: boolean;
  marginBottom?: number;
  style?: StyleProp<ViewStyle>;
}

export function MBDefaultError({ message, isRounded = true, marginBottom = 8, style }: Props) {
  const colors = useContext(ColorThemeContext);
  const errorMessage = message ?? i18n('errors.loading');

  return (
    <MBView
      style={[
        { backgroundColor: colors.error.background },
        isRounded && styles.rounded,
        { marginBottom },
        style,
      ]}
      padding={2}
      paddingVertical={1.75}
    >
      <MBText color={colors.error.foreground} style={styles.errorMessage}>
        {errorMessage}
      </MBText>
    </MBView>
  );
}

const styles = StyleSheet.create({
  rounded: {
    borderRadius: grid(1),
  },
  errorMessage: {
    fontSize: grid(2),
    fontWeight: 'normal',
    textAlign: 'center',
  },
});
